import { render, staticRenderFns } from "./riwayatKeluarga.vue?vue&type=template&id=2ccb2f2c&scoped=true&"
import script from "./riwayatKeluarga.vue?vue&type=script&lang=js&"
export * from "./riwayatKeluarga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccb2f2c",
  null
  
)

export default component.exports